export const MORE_INFO_MODAL_HEADER_ICON_SIZE = 40;
